import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const leadsRoutes: Routes = [
  {
    path: 'leads',
    loadComponent: () =>
      import('./leads.component').then((c) => c.LeadsComponent),
    canActivate: [AuthGuard],
  },
];
